export default __webpack_public_path__ + "static/media/redRibbonRedOutlined.2e3a69c5.svg";